var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPropActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_30522)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    stroke: "#001489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.12505H9.3975C9.37137 7.1215 9.34488 7.1215 9.31875 7.12505H9.255C9.2354 7.13623 9.21661 7.14876 9.19875 7.16255C9.17787 7.17634 9.15783 7.19136 9.13875 7.20755C9.12623 7.22288 9.11495 7.23918 9.105 7.2563C9.08782 7.27992 9.07276 7.30502 9.06 7.3313V7.3313L8.46 8.98505L6.89625 4.74755C6.86997 4.67515 6.82205 4.61261 6.75898 4.5684C6.69591 4.5242 6.62076 4.50049 6.54375 4.50049C6.46673 4.50049 6.39159 4.5242 6.32852 4.5684C6.26545 4.61261 6.21753 4.67515 6.19125 4.74755L5.325 7.12505H4.125C4.02554 7.12505 3.93016 7.16456 3.85983 7.23488C3.78951 7.30521 3.75 7.40059 3.75 7.50005C3.75 7.5995 3.78951 7.69489 3.85983 7.76521C3.93016 7.83554 4.02554 7.87505 4.125 7.87505H5.595H5.68125H5.7375C5.75881 7.86479 5.77894 7.85221 5.7975 7.83755C5.81838 7.82376 5.83842 7.80873 5.8575 7.79255L5.89125 7.7438C5.90912 7.72064 5.92423 7.69547 5.93625 7.6688L6.54375 5.97005L8.10375 10.2525C8.12995 10.325 8.17785 10.3877 8.24092 10.432C8.304 10.4762 8.37918 10.5 8.45625 10.5C8.53332 10.5 8.6085 10.4762 8.67158 10.432C8.73465 10.3877 8.78255 10.325 8.80875 10.2525L9.67125 7.87505H10.875C10.9745 7.87505 11.0698 7.83554 11.1402 7.76521C11.2105 7.69489 11.25 7.5995 11.25 7.50005C11.25 7.40059 11.2105 7.30521 11.1402 7.23488C11.0698 7.16456 10.9745 7.12505 10.875 7.12505Z",
    fill: "#001489",
    stroke: "#001489",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_30522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPropActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prop-active.55dbe20029d3861342535f167c51ddf8.svg";